module.exports = __webpack_public_path__ + "assets/icon-plugin-selected.71307341.svg";